import styled from "styled-components";
const Container = styled.div`
  height:100vh;
  display:flex;
  justify-content:space-between;
  align-items:center;
`
export default function Success() {
  return (
    <Container>
        Success
    </Container>
  )
}
